//import React, { Component } from 'react';
import { Component } from 'react';

class QualifierResultEdit extends Component {
  constructor(props) {
    super();

    this.state = {};
  }


  render() {
    return (
      null
    //   <div
    //     style={{ backgroundColor: "#fafafa" }}
    //     contentEditable
    //     suppressContentEditableWarning
    //     onBlur={e => {
    //       const data = [...this.state.data];
    //       data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
    //       this.setState({ data });
    //     }}
    //     dangerouslySetInnerHTML={{
    //       __html: this.state.data[cellInfo.index][cellInfo.column.id]
    //     }}
    //   />
    );
  };
};

export default QualifierResultEdit;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/QualifierResultEdit.js